import React from "react";
import ReactDOM from "react-dom/client";

import { LocaleProvider } from "@app/scripts/react-providers/locales";
import { ProductStl } from "@app/scripts/react-product-stl/components/ProductStl";

import type { Product } from "@app/scripts/types";

const ProductStlElem = class extends HTMLElement {
  static observedAttributes = ["header-image", "btn-style"];

  connectedCallback() {
    const headerImage = this.getAttribute("header-image");
    const btnStyle = this.getAttribute("btn-style") || "default";
    const btnColor = this.getAttribute("btn-color") || "white";
    const products: Product[] = [];

    this.querySelectorAll("[data-json]").forEach((script) => {
      try {
        const product = JSON.parse(script.innerHTML);

        if (product) products.push(product);
      } catch (error) {
        console.error(error);
      }
    });

    const root = ReactDOM.createRoot(this);
    root.render(
      <LocaleProvider>
        <ProductStl products={products} headerImage={headerImage} btnStyle={btnStyle} btnColor={btnColor} />
      </LocaleProvider>
    );
  }
};

customElements.define("product-stl", ProductStlElem);
